import React from "react";
import { Control } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import CompanyType from "@/components/molecules/RegisterCompanySteps/CompanyType";
import MembershipType from "@/components/molecules/RegisterCompanySteps/MembershipType";
import CompanyLanguage from "@/components/molecules/RegisterCompanySteps/CompanyLanguage";
import Timezone from "@/components/molecules/RegisterCompanySteps/Timezone";

interface SettingsPanelProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const SettingsPanel: React.FC<SettingsPanelProps> = ({ control, saveDraft }) => {
  return (
    <React.Fragment>
      <CompanyLanguage control={control} saveDraft={saveDraft} />
      <Timezone control={control} saveDraft={saveDraft} />
      <CompanyType control={control} saveDraft={saveDraft} />
      <MembershipType control={control} saveDraft={saveDraft} />
    </React.Fragment>
  );
};

export default SettingsPanel;
